import React, {useCallback, useMemo, useState} from 'react';
import styled, {useTheme} from "styled-components";
import EventMangFilter from "./EventMangFilter";
import useDeeplolEvent from "../../common/hooks/useDeeplolEvent";
import EventMangTable from "./EventMangTable";
import {useTranslation} from "react-i18next";
import {ImageLane} from "../common";
import {changePositionNameToImgPositionName} from "../../function";
import {MarginBox} from "../ui/styled";
import EventMangGraph from "./EventMangGraph";


const Wrapper = styled.div`
  margin-top: 52px;
  width: 100%;
`;
const FilterWrapper = styled.div`
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 10px;
  width: 100%;
  padding: 10px 16px;
  background-color: ${props => props.theme.color.site_main_color};
`;

const TeamBox = styled.div`
  background-color: ${props => props.theme.color.site_main_color};
  border: 1px solid ${props => props.theme.color.green_100};
  border-radius: 10px;
  overflow: hidden;
  margin-top: 16px;
`;

const TeamHeader = styled.div`
  display: flex;
  flex-direction: row;
  height: 140px;
  border-bottom: 1px solid ${props => props.theme.color.green_100};
  padding: 24px 16px;
`;

const TeamInfoBox = styled.div`
  width: 100%;
  margin: 8.5px 0;
`;

const TeamImageBox = styled.div`
  width: 136px;
  height: 96px;
  margin-right: 16px;
  object-fit: cover;
  img {
    max-width: 128px;
  }
`;
const TeamNameInfo = styled.div`
  height: 35px;
  width: 55px;
  background-color: ${props => props.theme.color.green_200};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.color.green_100};
  font-weight: 700;
  font-size: 18px;
  border-radius: 6px;
`;
const TeamRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const TeamName = styled.div`
  font-weight: 700;
  font-size: 20px;
  color: ${props => props.theme.color.green_100};
  margin-left: 8px;
`;
const PlayersBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 8px;
  height: 36px;
  border-radius: 8px;
  background-color: ${props => props.theme.color.white_201};
  margin-top: 8px;
`;
const LeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const LeaderSpan = styled.span`
  font-weight: 900;
  font-size: 14px;
  color: ${props => props.theme.color.dark_200};
`;

const PlayerSpan = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.color.dark_200};
`;
const EventMangContent = () => {
    const {list, query} = useDeeplolEvent('bjm')
    // const {list, query} = useSliApi({tournamentName:'sll'});
    // const [selectedTeamId, setSelectedTeamId] = useState(list.all_teams[0].team_id);
    // const selectedTeam = useMemo(() => {
    //     try {
    //         const result = list.all_teams.find((data) => data.team_id === selectedTeamId)
    //         if (result.team_name) {
    //             return result;
    //         }
    //         return "error"
    //     } catch (e) {
    //         return "error"
    //     }
    // }, [selectedTeamId, list.all_teams])
    const [filterSelected, setFilterSelected] = useState('');
    const [categorySelected, setCategorySelected] = useState('all');

    const getGroup = (group) => {
        return list.team_list.filter((data) => group.includes(data.team));
    }

    const filterList = useMemo(() => {
        try {
            if (categorySelected === 'all') {
                return list.team_list
            } else if (categorySelected === 'role') {
                return list.position
            } else if(categorySelected === 'A') {
                return getGroup(list.group_filter.A)
            } else if(categorySelected === 'B') {
                return getGroup(list.group_filter.B)
            }
            return []
        } catch (e) {
            return []
        }
    }, [filterSelected, categorySelected, list])


    const mapList = useMemo(() => {
        try {
            if (!filterSelected) {
                return filterList
            }

            const findTeam = filterList.find((data) => data.team === filterSelected)
            if (!findTeam) {
                return []
            }
            return [findTeam]
        } catch (e) {
            console.log(e)
            return []
        }
    }, [filterSelected, categorySelected, filterList]);

    console.log("mapList", filterList);

    return (
        <Wrapper>
            <MarginBox margin={'0 0 16px 0'}>
                <img src={'/images/mang/icon_event_banner.png'} width={1080} height={320} alt={''}/>
            </MarginBox>
            <EventMangGraph list={list.tournament}/>
            <FilterWrapper>
                <EventMangFilter
                    filterTeam={filterSelected}
                    setFilterTeam={setFilterSelected}
                    teamList={filterList}
                    setCategorySelected={setCategorySelected}
                    categorySelected={categorySelected}
                />
            </FilterWrapper>
            <TableController filterTeam={categorySelected} mapList={mapList} teamList={list.teams_name} />
        </Wrapper>
    );
};


const CardWrapper = styled.div`
  background-color: ${props => props.theme.color.site_main_color};
  border: 2px solid ${props => props.theme.color.green_100};
  border-radius: 6px;
  overflow: hidden;

  margin-top: 14px;
`;


const ListWrapper = styled.div`
  & + & {
    margin-top: 20px;
  }
`;
const TableController = ({mapList, filterTeam, teamList}) => {
    if(!mapList) {
        return null;
    }

    if (filterTeam === 'role' ) {
        return (
            <div>
                {mapList.map((item) => {
                    return (
                        <ListWrapper>
                            <CardWrapper>
                                <PositionBox position={changePositionNameToImgPositionName(item.team)}/>
                                <EventMangTable list={item.players} team={""}
                                                disableTeam={true} most={true}/>
                            </CardWrapper>
                        </ListWrapper>
                    )
                })}

                {/*<ListWrapper>*/}
                {/*    <CardWrapper>*/}
                {/*        <PositionBox position={'jungle'}/>*/}
                {/*        <EventMangTable list={positionList[1].players} team={""}*/}
                {/*                        disableTeam={true} most={true}/>*/}
                {/*    </CardWrapper>*/}
                {/*</ListWrapper>*/}
                {/*<ListWrapper>*/}
                {/*    <CardWrapper>*/}

                {/*        <PositionBox position={'middle'}/>*/}
                {/*        <EventMangTable list={positionList[2].players} team={""}*/}
                {/*                        disableTeam={true} most={true}/>*/}
                {/*    </CardWrapper>*/}
                {/*    /!*<EventChart list={item}*!/*/}
                {/*    /!*            tierOff={currentTierOff}/>*!/*/}
                {/*</ListWrapper>*/}
                {/*<ListWrapper>*/}
                {/*    <CardWrapper>*/}

                {/*        <PositionBox position={'bot'}/>*/}
                {/*        /!*<EventTeamComment leader={leader} team={leader.team_name} teamList={item} tag={score_sum}/>*!/*/}
                {/*        <EventMangTable list={positionList[3].players} team={""}*/}
                {/*                        disableTeam={true} most={true}/>*/}
                {/*    </CardWrapper>*/}
                {/*    /!*<EventChart list={item}*!/*/}
                {/*    /!*            tierOff={currentTierOff}/>*!/*/}
                {/*</ListWrapper>*/}
                {/*<ListWrapper>*/}
                {/*    <CardWrapper>*/}
                {/*        <PositionBox position={'supporter'}/>*/}

                {/*        /!*<EventTeamComment leader={leader} team={leader.team_name} teamList={item} tag={score_sum}/>*!/*/}
                {/*        <EventMangTable list={positionList[4].players} team={""}*/}
                {/*                        disableTeam={true} most={true}/>*/}
                {/*    </CardWrapper>*/}
                {/*    /!*<EventChart list={item}*!/*/}
                {/*    /!*            tierOff={currentTierOff}/>*!/*/}
                {/*</ListWrapper>*/}
            </div>
        )
    }



    return (
        <div>
            {mapList.map((data, index) => {
                const leader = data.players.find((item) => data.team === item.name);
                const teamName = teamList?.[data?.team]
                return (
                    <TeamBox
                        key={index}
                    >
                        <TeamHeader>
                            <TeamImageBox>
                                <img
                                    src={`${process.env.REACT_APP_ROOT_IMG}${leader?.status?.toLowerCase()}/${leader?.name}.png`}
                                     height={96} alt={''}
                                    onError={(e) => e.target.src = '/images/img_unknown.svg'}/>
                            </TeamImageBox>
                            <TeamInfoBox>
                                <TeamRow>
                                    <TeamNameInfo>
                                        팀장
                                    </TeamNameInfo>
                                    <TeamName>
                                        {leader?.name}
                                    </TeamName>
                                </TeamRow>
                                <PlayersBox>
                                    <LeaderBox>
                                        <LeaderSpan>{teamName}</LeaderSpan> </LeaderBox>
                                </PlayersBox>
                            </TeamInfoBox>
                        </TeamHeader>
                        <EventMangTable list={data?.players} positionRank={true}/>
                    </TeamBox>
                )
            })}
        </div>
    )
}

const PositionBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 12px;
  border-bottom: 2px solid ${props => props.theme.color.green_100};

  .imgLane {
    width: 22px;
    height: 22px;
  }
`;
const PositionSpan = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: ${props => props.theme.color.green_100};
`;
const PositionTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 36px;
  margin-left: 10px;
`;

const PositionBox = ({position}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    const getLaneName = useCallback((lane) => {
        switch (lane.toLowerCase()) {
            case 'top':
                return t('gameAnalytics.top')
            case 'jungle':
                return t('gameAnalytics.jungle')
            case 'middle':
                return t('gameAnalytics.mid')
            case 'bot':
                return t('gameAnalytics.bot')
            case 'supporter':
                return t('gameAnalytics.support')
            default:
                break;
        }
    }, []);


    return (
        <PositionBoxWrapper>
            <ImageLane
                lane={position}
                color={theme.color.theme === 'dark' ? 'light' : 'dark'}
            />
            <PositionTextWrapper>
                <PositionSpan>{getLaneName(position)} {t('lck.position')}</PositionSpan>
            </PositionTextWrapper>
        </PositionBoxWrapper>
    )


}

export default EventMangContent;